import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon SpecSheetIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const SpecSheetIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 16 20">
      <path d="M13.333 0H2.667A2.669 2.669 0 000 2.667v14.666A2.67 2.67 0 002.667 20h10.666A2.671 2.671 0 0016 17.333V2.667A2.67 2.67 0 0013.333 0zM14 17.333a.668.668 0 01-.667.667H2.667A.668.668 0 012 17.333V2.667A.667.667 0 012.667 2h10.666a.667.667 0 01.667.667z" />
      <path d="M10 4.625H6a1 1 0 000 2h4a1 1 0 000-2zM10 8.626H6a1 1 0 000 2h4a1 1 0 000-2zM10 12.626H6a1 1 0 000 2h4a1 1 0 000-2z" />
    </Icon>
  )
}
export default SpecSheetIcon
